import React, { useRef, useEffect, useState } from "react";
import "./SharedReportStyles.css";
import "./ObservacionesComentarios.css";

const ActividadesRealizadas = ({ seccion, updateItemResponse, renderCase }) => {
  // Comprobación de seguridad para evitar errores
  const items = seccion && seccion.items 
    ? [...seccion.items].sort((a, b) => (a.orden || 0) - (b.orden || 0)) 
    : [];
  
  return (
    <div className="sr-section">
      <p className="sr-section-title">{seccion.nombreseccion}</p>
      <div className="oc-container">
        {items.map((item) => (
          <Item
            key={item.id || Math.random()}
            item={item}
            updateItemResponse={updateItemResponse}
            seccion={seccion.idseccionreporte}
            renderCase={renderCase}
          />
        ))}
        {/* Si no hay items, crear un textarea vacío */}
        {items.length === 0 && (
          <div className="item">
            <textarea
              className="oc-textarea"
              placeholder="Sin actividades disponibles"
              readOnly
            ></textarea>
          </div>
        )}
      </div>
    </div>
  );
};

const Item = ({ item, updateItemResponse, seccion, renderCase }) => {
  // Determinar si el item requiere input o es solo un label
  const requiereInput = item.idtipoitem === 1 && item.idtiporespuesta;
  
  return (
    <div className="item" style={{width: '100%'}}>
      {/* Si no requiere input, mostrar solo el texto como pre para preservar formato */}
      {!requiereInput && (
        <pre className="ar-item-label oc-text-pre">{item.descripcion}</pre>
      )}
      
      {/* Si requiere input, mostrar el componente ItemInput */}
      {requiereInput && (
        <>
          <pre className="ar-item-description oc-text-pre">{item.descripcion}</pre>
          <ItemInput
            item={item}
            updateItemResponse={updateItemResponse}
            seccion={seccion}
            renderCase={renderCase}
          />
        </>
      )}
    </div>
  );
};

const ItemInput = ({ item, updateItemResponse, seccion, renderCase }) => {
  const textareaRef = useRef(null);
  const [localRespuesta, setLocalRespuesta] = useState(item.respuesta || "");

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [localRespuesta]);

  const handleInput = (value) => {
    setLocalRespuesta(value);
    
    if (updateItemResponse) {
      updateItemResponse(
        seccion,
        item.id,
        item.idrespuestaitem,
        item.idrespuestabooleana,
        item.idrespuestanumerica,
        item.idrespuestatexto,
        item.idrespuestaimagen,
        value
      );
    }
  };

  // Para modo visualización
  if (renderCase === "view") {
    // Manejar diferentes tipos de respuesta para visualización
    if (item.idtiporespuesta === 1) { // Booleano
      return <pre className="oc-label oc-text-pre">{item.respuesta === true ? "Sí" : item.respuesta === false ? "No" : "N/A"}</pre>;
    } else {
      // Usar pre para preservar saltos de línea
      return <pre className="oc-label oc-text-pre">{item.respuesta || "Sin respuesta"}</pre>;
    }
  }
  
  // Para modo creación
  if (renderCase === "create") {
    switch (item.idtiporespuesta) {
      case 1: // Booleano
        return (
          <div className="oc-checkbox-container">
            <label>
              <input
                type="checkbox"
                checked={localRespuesta === true}
                onChange={() => handleInput(true)}
              />{" "}
              Sí
            </label>
            <label>
              <input
                type="checkbox"
                checked={localRespuesta === false}
                onChange={() => handleInput(false)}
              />{" "}
              No
            </label>
            <label>
              <input
                type="checkbox"
                checked={localRespuesta === null}
                onChange={() => handleInput(null)}
              />{" "}
              N/A
            </label>
          </div>
        );
      case 2: // Numérico
        return (
          <textarea
            ref={textareaRef}
            className="oc-textarea oc-numeric"
            placeholder="Ingresa un valor numérico..."
            value={localRespuesta || ""}
            onInput={(e) => handleInput(e.target.value)}
          ></textarea>
        );
      default: // Texto u otros
        return (
          <textarea
            ref={textareaRef}
            className="oc-textarea"
            placeholder="Haz click para añadir actividad..."
            value={localRespuesta || ""}
            onInput={(e) => handleInput(e.target.value)}
          ></textarea>
        );
    }
  }
  
  // Para "newFormat" o cualquier otro caso, mostrar textarea de solo lectura
  return (
    <textarea
      ref={textareaRef}
      className="oc-textarea"
      placeholder="Vista previa de actividad"
      value={localRespuesta || ""}
      style={{width: '100%'}}
      readOnly
    ></textarea>
  );
};

export default ActividadesRealizadas;